module.exports = "/images/Circle.svg";